import { styled, Typography } from '@mui/material';

export const PreviewSection = styled('div')`
  margin-bottom: 8px;
  background-color: #fbfbfb;
  backdrop-filter: blur(20px);
  border-radius: 8px;

  @media (max-width: 1023px) {
    padding: 0px 11px 23px;
  }
`;

export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 40px;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const InnerContainer = styled('div')`
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  margin-top: 24px;
  @media (max-width: 1023px) {
    margin-top: 8px;
  }
`;

export const Subtitle = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 12px;
`;

export const VisionW = styled('div')`
  background: ${({ theme }) => theme.palette.white.main};
  box-shadow: 0px 25px 12px -20px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 16px;
`;

export const VisionCardHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const VisionIconBg = styled('div')`
  background-color: ${({ theme }) => theme.palette.info.main};
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 22px;
    height: 22px;
    fill: white;
    stroke: white;
  }
`;

export const VisionContent = styled('div')`
  color: ${({ theme }) => theme.palette.primary.p080};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  word-break: break-word;
  overflow: hidden;
  cursor: pointer;

  & p {
    margin: 12px 0;

    &:has(code) {
      margin: 4px 0;
    }

    &:first-of-type {
      margin-top: 0;
    }
  }

  & h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 0;
    font-size: inherit;
  }

  & a {
    color: ${({ theme }) => theme.palette.info.main};
  }
`;
